import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import * as appActions from './app.actions';
import { ApplictionsTypes, UserSubscription } from './app.actions';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { UserService } from '../global/services/user.service';
import { AuthService } from '../global/services/auth.service';
import { SessionService } from '../global/services/session.service';
import { UserSubscriptionService } from '../global/services/user-subscription.service';
import { InitialUnreadCountModel } from '../shared/data/models/initial-unread-count.model';
import { NewUnreadModel } from '../shared/data/models/new-unread.model';

@Injectable()
export class AppEffects {
  constructor(
    private actions$: Actions,
    private userService: UserService,
    private authService: AuthService,
    private sessionService: SessionService,
    private userSubscriptionService: UserSubscriptionService
  ) {}

  @Effect()
  loadUser$ = this.actions$.pipe(
    ofType(ApplictionsTypes.LoadUser),
    switchMap(_ =>
      this.userService.getMe().pipe(
        tap(d => console.error(d)),
        map(userRes => {
          if (userRes.errors) {
            return new appActions.LoadUserError(userRes.errors[0].message);
          }
          return new appActions.LoadUserSuccess(userRes.data.me);
        }),
        catchError(error => {
          return of(new appActions.LoadUserError(error));
        })
      )
    )
  );

  @Effect()
  refreshLiveUser$ = this.actions$.pipe(
    ofType(ApplictionsTypes.RefreshLiveUser),
    switchMap(_ => {
      const token = this.sessionService.getToken();
      return this.authService.refreshToken(token).pipe(
        tap(res => {
          console.error(res);
          this.sessionService.saveTokenData(res.token, res.expire, true);
          // reload the whole page so that load me can do it magic
          window.location.href = '/';
        }),
        catchError(err => {
          return of(new appActions.LoadUserError(err));
        })
      );
    })
  );

  @Effect({ dispatch: true })
  setNotifications$ = this.actions$.pipe(
    ofType(ApplictionsTypes.SetNotifications),
    switchMap(_ =>
      this.userSubscriptionService.notificationSubscription().pipe(
        map(res => {
          if (res.data) {
            if (res.data.unreadCounters?.__typename === 'InitialUnreadCount') {
              const initialNot = res.data
                .unreadCounters as InitialUnreadCountModel;
              return new appActions.LoadNotificationSuccess(initialNot);
            } else {
              const incrementalNotif = res.data
                .unreadCounters as NewUnreadModel;
              if (incrementalNotif.emission === 'MESSAGE') {
                return new appActions.IncrementMessageNotification();
              } else {
                return new appActions.IncrementNormalNotification();
              }
            }
          }
        })
      )
    )
  );

  @Effect()
  meSubscription$ = this.actions$.pipe(
    ofType<UserSubscription>(ApplictionsTypes.UserSubscription),
    switchMap(_ =>
      this.userSubscriptionService.meSubscription().pipe(
        map(res => {
          if (res.data) {
            return new appActions.LoadUserSuccess(res.data.me);
          }
        })
      )
    )
  );
}
